import constants from "@/config/constants";
import { generateQueryString, generateProxyUsername } from "@/utils/template_utils";

const templates = {
    CURL: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            return `curl --request GET \\\n` +
                `--url 'https://${constants.API_SERVICE_HOST}${path}?${generateQueryString(request_generator, api_token)}'`;
        }
    },

    PYTHON: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            return `import http.client\n` +
                `\n` +
                `conn = http.client.HTTPSConnection("${constants.API_SERVICE_HOST}")\n` +
                `\n` +
                `conn.request("GET", "${path}?${generateQueryString(request_generator, api_token)}")\n` +
                `\n` +
                `res = conn.getresponse()\n` +
                `data = res.read()\n` +
                `\n` +
                `print(data.decode("utf-8"))`
        },
    },

    NODE_JS: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            return `var http = require("https");\n` +
                `\n` +
                `var options = {\n` +
                `   "method": "GET",\n` +
                `   "hostname": "${constants.API_SERVICE_HOST}",\n` +
                `   "port": null,\n` +
                `   "path": "${path}?${generateQueryString(request_generator, api_token)}",\n` +
                `   "headers": {\n` +
                `       "useQueryString": true\n` +
                `   }\n` +
                `};\n` +
                `\n` +
                `var req = http.request(options, function (res) {\n` +
                `   var chunks = [];\n` +
                `   res.on("data", function (chunk) {\n` +
                `       chunks.push(chunk);\n` +
                `   });\n` +
                `\n` +
                `   res.on("end", function () {\n` +
                `       var body = Buffer.concat(chunks);\n` +
                `       console.log(body.toString());\n` +
                `   });\n` +
                `});\n` +
                `\n` +
                `req.end();`
        },
    },
    PHP: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            const queryString = generateQueryString(request_generator, api_token);
            return `<?php\n` +
                `$url = 'https://${constants.API_SERVICE_HOST}${path}?${queryString}';\n` +
                `\n` +
                `$options = [\n` +
                `    'http' => [\n` +
                `        'method' => 'GET',\n` +
                `        'header' => 'Content-Type: application/json'\n` +
                `    ]\n` +
                `];\n` +
                `\n` +
                `$context = stream_context_create($options);\n` +
                `$response = file_get_contents($url, false, $context);\n` +
                `\n` +
                `if ($response === false) {\n` +
                `    die('Error fetching data');\n` +
                `}\n` +
                `\n` +
                `echo $response;\n` +
                `?>`;
        }
    },

    JAVA: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            const queryString = generateQueryString(request_generator, api_token);
            return `import java.net.HttpURLConnection;\n` +
                `import java.net.URL;\n` +
                `import java.io.BufferedReader;\n` +
                `import java.io.InputStreamReader;\n` +
                `\n` +
                `public class ScrapingAntExample {\n` +
                `    public static void main(String[] args) throws Exception {\n` +
                `        String url = "https://${constants.API_SERVICE_HOST}${path}?${queryString}";\n` +
                `        \n` +
                `        URL obj = new URL(url);\n` +
                `        HttpURLConnection conn = (HttpURLConnection) obj.openConnection();\n` +
                `        conn.setRequestMethod("GET");\n` +
                `        \n` +
                `        BufferedReader reader = new BufferedReader(\n` +
                `            new InputStreamReader(conn.getInputStream())\n` +
                `        );\n` +
                `        \n` +
                `        String line;\n` +
                `        StringBuilder response = new StringBuilder();\n` +
                `        while ((line = reader.readLine()) != null) {\n` +
                `            response.append(line);\n` +
                `        }\n` +
                `        reader.close();\n` +
                `        \n` +
                `        System.out.println(response.toString());\n` +
                `    }\n` +
                `}`;
        }
    },

    CSHARP: {
        get: (request_generator, api_token) => {
            const path = `${constants.API_SERVICE_PATH}/${request_generator.response_type}`;
            const queryString = generateQueryString(request_generator, api_token);
            return `using System;\n` +
                `using System.Net.Http;\n` +
                `using System.Threading.Tasks;\n` +
                `\n` +
                `class Program\n` +
                `{\n` +
                `    static async Task Main(string[] args)\n` +
                `    {\n` +
                `        using var client = new HttpClient();\n` +
                `        \n` +
                `        string url = "https://${constants.API_SERVICE_HOST}${path}?${queryString}";\n` +
                `        \n` +
                `        string response = await client.GetStringAsync(url);\n` +
                `        \n` +
                `        Console.WriteLine(response);\n` +
                `    }\n` +
                `}`;
        }
    },

    PROXY: {
        get: (request_generator, api_token) => {
            const proxyUsername = generateProxyUsername(request_generator);
            return `{\n` +
               `    http: '${proxyUsername}:${api_token}@proxy.scrapingant.com:8080',\n` +
               `    https: '${proxyUsername}:${api_token}@proxy.scrapingant.com:443'\n` +
                `}`;
        }
    },
}

export default templates
